import { View } from "extensions/marionette";
import moment from "moment";
import styled from "styled-components";

import { helpTip, accounting } from "common/utils";
import strings from "common/strings";

import { WebixDatatable } from "common/components/webix/react/Datatable";

import summaryTemplate from "./summary.jst";
import template from "./tabBody.jst";

const ROW_HEIGHT = 26;
const TABLE_HEADER_HEIGHT = 43;

const Summary = View.extend({
    template: summaryTemplate,
    className: "summary-bar",
    serializeData() {
        const data = View.prototype.serializeData.apply(this, arguments);
        data.count = this.formatNumber(data.count);
        data.amount = this.formatAmountWithCurrentCurrency(data.amount);
        return data;
    }
});

function TabTable({ data, widgetEl }) {
    const tabsNaviHeight = widgetEl.find(".nav-tabs").outerHeight(true);
    const parentHeaderHeight = widgetEl.find(".header").outerHeight(true);
    const summaryHeight = widgetEl.find(".summary").outerHeight(true);
    const tableBodyHeight = widgetEl.find(".grid-stack-item-content").outerHeight(true) - tabsNaviHeight - parentHeaderHeight - summaryHeight - TABLE_HEADER_HEIGHT;
    const numRows = Math.floor(tableBodyHeight / ROW_HEIGHT) | 0;
    
    const ui = {
        rowHeight: ROW_HEIGHT,
        yCount: numRows,
        scroll: false,
        columns: [
            {
                header: strings.month,
                id: "month",
                fillspace: true,
                format(month) {
                    const date = moment(month);
                    const lastDay = moment.min(date.clone().endOf("month"), moment.utc());
                    return `${date.format("MMM")} ${date.startOf("month").format("D")} - ${lastDay.format("D")}, ${lastDay.format("YYYY")}`;
                }
            },
            {
                header: strings.analytics.chargebacks.chargebackRate,
                id: "rate",
                fillspace: true,
                template({ rate, partial }) {
                    const formatted = accounting.getRate({
                        rate,
                        humanize: true,
                        precision: 4,
                        addFloatValue: false
                    });
                    
                    if (partial) {
                        return (
                            <span>
                                {formatted}
                                <span className="estimated">
                                    ({strings.dashboard.widgets.rate_network.estimated}) {helpTip(strings.dashboard.widgets.rate_network.estimated_tooltip)}
                                </span>
                            </span>
                        );
                    }
                    
                    return formatted;
                }
            }
        ]
    };

    return <WebixDatatable className="tab-table" data={data} ui={ui} />;
}

const TabTableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .tab-table {
        flex: 1;
    }
`;

export const TabBody = View.extend({
    template,
    regions: {
        summary: ".summary",
        table: ".table"
    },
    
    makeSummary() {
        return new Summary({
            model: this.model
        });
    },
    
    makeTable() {
        return (
            <TabTableWrapper>
                <TabTable widgetEl={this.getOption("widget").$el} data={this.collection.toArray().map((model) => model.attributes)} />
            </TabTableWrapper>
        );
    },
    
    onAttach() {
        this.showChildView("summary", this.makeSummary(), { waitForAttach: true });
        this.showChildView("table", this.makeTable(), { waitForAttach: true });
    }
});
